
interface ICodepen {
  title: string;
  penId: string;
  defaultTab?: string;
  editable?: boolean;
  height?: string | number;
  width?: string | number;
}

export default function CodePen({ title, penId, editable = false, defaultTab = 'html', height = '400', width = '100%' }: ICodepen) {
  return (
    <iframe
      height={height}
      style={{ width }}
      title={title}
      src={`https://codepen.io/varguitas/embed/${penId}?default-tab=${defaultTab}%2Cresult&theme-id=dark&editable=${editable}`}
      loading="lazy"
      allowTransparency={true}
      allowFullScreen={true}
    >
      See the Pen{" "}
      <a href={`https://codepen.io/varguitas/pen/${penId}`}>
        Basic HTML Structure
      </a>{" "}
      by Víctor Gerardo Vargas Ramírez
    </iframe>
  );
}
